import { render } from "./Result.vue?vue&type=template&id=5c08b4b0&scoped=true"
import script from "./Result.vue?vue&type=script&lang=ts"
export * from "./Result.vue?vue&type=script&lang=ts"

import "./Result.vue?vue&type=style&index=0&id=5c08b4b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c08b4b0"

export default script